export const types = {
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
};

export interface ISetError {
    errorHeader: string;
    errorBody: string;
}
